"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChangeToPlaylistCallback = void 0;
const ScreenState_1 = require("../types/ScreenState");
const SidebarButtonType_1 = require("../types/SidebarButtonType");
const TracksType_1 = require("../types/TracksType");
function createChangeToPlaylistCallback(tracksModel, sidebarPresenter) {
    return (playlistData) => {
        tracksModel.tracksTitle = playlistData.name;
        tracksModel.tracksType = TracksType_1.TracksType.Playlist;
        tracksModel.playlistId = playlistData.id;
        tracksModel.setAll(playlistData.songs);
        sidebarPresenter.activeButton = SidebarButtonType_1.SidebarButtonType.Tracks;
        tracksModel.tracksType = TracksType_1.TracksType.Playlist;
        sidebarPresenter.render();
        tracksModel.onChange(ScreenState_1.ScreenState.Tracks);
    };
}
exports.createChangeToPlaylistCallback = createChangeToPlaylistCallback;
